import "../App.css";

import Navbar from "../components/navbar"
import Warning from "../components/warning";
import Footer from "../components/footer";
import { Helmet } from "react-helmet";

import { useInView } from "react-intersection-observer";

const FadeInTitle = ({ children }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <p ref={ref} className={`fade-in Sector Concert Center Cyan ${inView ? "visible" : ""}`}>
      {children}
    </p>
  );
};

const Unavailable = () => {
  return (
    <div className="App">
      <Helmet>
        <title>Heartland Fun: Game Info</title>
        <meta name="title" content="Heartland Fun: Game Info" />
        <meta name="description" content="Heartland Fun Amusement offers a variety of arcade equipment to create unforgettable experiences for your business with easy, hassle-free purchasing." />
        <meta name="keywords" content="Arcade equipment, Claw machines, Gaming systems, Amusement supplier, Business entertainment, Arcade experience, Hassle-free purchasing, Entertainment solutions, Fun equipment, Gaming for businesses" />
        <meta name="robots" content="index, follow" />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="language" content="English" />
        <meta property="og:title" content="Heartland Fun: Game Info" />
        <meta property="og:type" content="website" />
        <meta property="og:description " content="Heartland Fun Amusement offers a variety of arcade equipment to create unforgettable experiences for your business with easy, hassle-free purchasing." />
        <meta property="og:determiner " content="" />
        <meta property="og:url" content="https://heartland.csfrederick.com/unavailable" />
        <meta property="og:image" content="https://heartland.csfrederick.com/Header.png" />
        <meta property="og:image:secure_url" content="https://heartland.csfrederick.com/Header.png" />
        <link rel="icon" href="/favicon.ico" />
      </Helmet>
      <Navbar></Navbar>
      <Warning></Warning>
      <FadeInTitle>
        PRODUCT INFORMATION
      </FadeInTitle>
      <br></br>
      <a href="tel:7858137921" className="Button Titillium Center">
        Get in Touch
      </a>
      <div className="Brake"></div>
      <p className="Blue InfoText Titillium Center FadeIn">
        Please note that product information is not fully available for all products at this time, but we are working hard to provide detailed descriptions and specifications for all of our products. In the meantime, if you have any questions or need additional details, feel free to reach out to us via phone or email. Our team is ready to assist you and provide the information you need.
      </p>
      <Footer></Footer>
    </div>
  );
};

export default Unavailable;